import { YourCarOutlineMdSVG } from 'lighthouse-icons';

import { CarOutlineMd } from 'components/icons/CarOutlineMd';
import { CarTwoToneMd } from 'components/icons/CarTwoToneMd';
import { MotorcycleOutlineMd } from 'components/icons/MotorcycleOutlineMd';
import { MotorcycleTwoToneMd } from 'components/icons/MotorcycleTwoToneMd';

export const plateFields = {
    twoDigitPlateNumber: 'twoDigitPlateNumber',
    threeDigitPlateNumber: 'threeDigitPlateNumber',
    fiveDigitPlateNumber: 'fiveDigitPlateNumber',
    serialNumber: 'serialNumber',
    plateCharacter: 'plateCharacter'
};
export const plateTypes = {
    default: 'default',
    normalReadOnly: 'normalReadOnly',
    normalReadOnlyWithOwnerInfo: 'normalReadOnlyWithOwnerInfo'
};

export const freeZonePlateNumbersObject = {
    gheshm: [
        { id: 1, title: 'GHESHM', value: 11, cityName: 'GHESHM' },
        { id: 1, title: '11', value: 11, cityName: 'GHESHM' },
        { id: 2, title: '12', value: 12, cityName: 'GHESHM' },
        { id: 3, title: '13', value: 13, cityName: 'GHESHM' }
    ],
    kish: [
        { id: 4, title: 'KISH', value: 22, cityName: 'KISH' },
        { id: 4, title: '22', value: 22, cityName: 'KISH' },
        { id: 5, title: '23', value: 23, cityName: 'KISH' },
        { id: 6, title: '24', value: 24, cityName: 'KISH' }
    ],
    arvand: [
        { id: 7, title: 'ARVAND', value: 33, cityName: 'ARVAND' },
        { id: 7, title: '33', value: 33, cityName: 'ARVAND' },
        { id: 8, title: '34', value: 34, cityName: 'ARVAND' },
        { id: 9, title: '35', value: 35, cityName: 'ARVAND' }
    ],
    maku: [
        { id: 10, title: 'MAKU', value: 44, cityName: 'MAKU' },
        { id: 10, title: '44', value: 44, cityName: 'MAKU' },
        { id: 11, title: '45', value: 45, cityName: 'MAKU' },
        { id: 12, title: '46', value: 46, cityName: 'MAKU' }
    ],
    aras: [
        { id: 13, title: 'ARAS', value: 55, cityName: 'ARAS' },
        { id: 13, title: '55', value: 55, cityName: 'ARAS' },
        { id: 14, title: '56', value: 56, cityName: 'ARAS' },
        { id: 15, title: '57', value: 57, cityName: 'ARAS' }
    ],
    anzali: [
        { id: 16, title: 'ANZALI', value: 66, cityName: 'ANZALI' },
        { id: 16, title: '66', value: 66, cityName: 'ANZALI' },
        { id: 17, title: '67', value: 67, cityName: 'ANZALI' },
        { id: 18, title: '68', value: 68, cityName: 'ANZALI' }
    ],

    chabahar: [
        { id: 19, title: 'CHABAHAR', value: 77, cityName: 'CHABAHAR' },
        { id: 19, title: '77', value: 77, cityName: 'CHABAHAR' },
        { id: 20, title: '78', value: 78, cityName: 'CHABAHAR' },
        { id: 21, title: '79', value: 79, cityName: 'CHABAHAR' }
    ],

    tehran: [
        { id: 22, title: 'TEHRAN', value: 88, cityName: 'TEHRAN' },
        { id: 22, title: '88', value: 88, cityName: 'TEHRAN' }
    ]
};
export const freeZonePlateNumberList = Object.values(freeZonePlateNumbersObject).reduce((current, accumulator) => [...accumulator, ...current], []);

export const vehiclePlateCar = {
    id: 1,
    type: 'CAR'
};

export const vehiclePlateMotorCycle = {
    id: 0,
    type: 'MOTORCYCLE'
};

export const vehiclePlateTypeId = {
    0: vehiclePlateMotorCycle.type,
    1: vehiclePlateCar.type
};

export const VehicleTypeIcons = {
    [vehiclePlateCar.id]: {
        label: 'خودرو',
        active: CarTwoToneMd,
        inactive: CarOutlineMd,
        default: YourCarOutlineMdSVG
    },
    [vehiclePlateMotorCycle.id]: {
        label: 'موتور سیکلت',
        active: MotorcycleTwoToneMd,
        inactive: MotorcycleOutlineMd,
        default: MotorcycleOutlineMd
    }
} as const;
